module.exports = __webpack_public_path__ + "img/icon-basis-ic-confirm.08d43327.svg";